

import simpleCheckboxes from '../components/simple-checkboxes';
import FilledForm from '../form/filled-form.vue';
import InputBox from './inputBox.vue';
import Form2 from '../form/form2.vue';

export default {
    name: 'checkin',
    components: {
        simpleCheckboxes,
        InputBox,
        FilledForm,
        Form2
    },
    created() {

        let t = this;

        for (let i = 1; i <= 18; i++) {
            t.list.people.push({ 'id': (i < 10 ? '0' : '') + i, 'text': i + '人' });
        }

        t.dict.people = listToDict(t.list.people);
        t.dict.source = listToDict(t.list.source);
        t.dict.bell_status = listToDict(t.list.bell_status);
        t.dict.clean_status = listToDict(t.list.clean_status);
        t.dict.check_status = listToDict(t.list.check_status);

        axios.get('employee?role=2').then(res => {
            if (res.data.status == 1) {
                let items = res.data.options.items;
                items.forEach(item => {
                    item.selected = false;
                });
                t.list.cleaner = items;
                t.dict.cleaner = listToDict(t.list.cleaner);
                t.loadData();
            }
        });

    },
    activated() {
        let t = this;
    },
    methods: {

        afterFormSubmitted(form_id) {
            this.gridItem.checkInItem.form_id = form_id;
            this.boxName = 'normal';
        },

        goContact() {
            A.err('この機能は現在ご利用いただけません。');
        },

        goFillForm() {
            this.boxName = 'fill-form';
        },

        viewForm() {
            this.boxName = 'view-form';
        },

        removeTag(item) {
            item.selected = false;
        },

        selectTag(item) {
            let t = this;
            item.selected = !item.selected;
        },

        openFilter(name) {

            let t = this;

            if (t.filterName == name) {
                t.filterName = '';
            }
            else {
                t.filterName = name;
            }

        },

        selectAll(key) {
            let t = this;

            if (key == 'tag' || key == 'cleaner' || key == 'room') {
                t.list[key].forEach(item => {
                    item.selected = true;
                });
            }
            else if (t.list[key] && t.search[key]) {
                t.search[key].clear();
                t.list[key].forEach(item => {
                    item._active = true;
                    t.search[key].push(item);
                });
            }

            t.$forceUpdate();
            t.filterData();
        },

        deselectAll(key) {
            let t = this;

            if (key == 'tag' || key == 'cleaner' || key == 'room') {
                t.list[key].forEach(item => {
                    item.selected = false;
                });
            }
            else if (t.list[key] && t.search[key]) {
                t.search[key].clear();
                t.list[key].forEach(item => {
                    item._active = false;
                });
            }
            t.$forceUpdate();
            t.filterData();
        },

        loadData() {

            let t = this;
            let p = {
                '_withTodayTask': t.today.format('yyyy-MM-dd'),
                '_withTodayOrders': t.today.format('yyyy-MM-dd'),
                '_withNextOrder': t.today.format('yyyy-MM-dd'),
                '_withRemark': t.today.format('yyyy-MM-dd'),
            };

            axios.get('room', { params: p }).then(res => {

                if (res.data.status == 1) {

                    let arr = res.data.options.items;

                    let s = t.stats = {
                        checkin: 0,
                        checkout: 0,
                        checkin_out: 0,
                        continuous: 0,
                        empty: 0,
                    };

                    let todayStr = t.today.format('yyyy-MM-dd');

                    arr.forEach(item => {

                        item.showOutsideRemark = false;
                        item.showInsideRemark = false;

                        item.selected = false;

                        item.has_checkin = false;
                        item.has_checkout = false;
                        item.has_continuous = false;
                        item.check_status = 0;
                        item.bell_status = 3;
                        item.people = 0;
                        item.is_empty = false;
                        item.is_emergency = false;
                        item._index = 100;
                        item.bgColor = 'bg-pink';

                        if (item.today_orders && item.today_orders.length > 0) {

                            item.today_orders.forEach(order => {
                                if (order.checkin_date == todayStr) {
                                    item.checkInItem = order;
                                    item.has_checkin = true;
                                    //当日有清扫任务并且已完成
                                    if (!item.today_task || (item.today_task && item.today_task.status == 3)) {
                                        s.checkin++;
                                        item.check_status = 4;
                                    }

                                    if (order.form_id)
                                        item.bell_status = 2;
                                    else
                                        item.bell_status = 1;
                                }
                                else if (order.checkout_date == todayStr) {
                                    item.has_checkout = true;
                                }
                                else {
                                    item.has_continuous = true;
                                    s.continuous++;
                                }
                            });

                            if (item.has_checkin && item.has_checkout) {
                                s.checkin_out++;
                            }
                            else if (!item.has_checkin && item.has_checkout) {
                                s.checkout++;
                            }

                        }
                        else {
                            item.is_empty = true;
                            s.empty++;
                        }

                        if (item.has_checkin && item.today_task && item.today_task.status == 3) {
                            item.bell_status = 3;
                        }

                        if (item.today_task) {
                            item.clean_status = item.today_task.status;
                            item.cleaner_id = item.today_task.cleaner_id;
                        }

                        if (item.next_order) {
                            item.is_emergency = item.next_order.emergency_status > 1;
                            item.people = Number(item.next_order.count_audlt) + Number(item.next_order.count_child) + Number(item.next_order.count_baby);
                            item.source = item.next_order.source;
                        }

                        if (item.check_status == 0) {
                            if (item.has_checkin) {
                                item.check_status = 1;
                            }
                            else if (item.has_checkout) {
                                item.check_status = 2;
                            }
                            else if (item.has_continuous) {
                                item.check_status = 3;
                            }
                        }

                        if (item.today_task) {
                            if (item.today_task.status == 1) {
                                if ((new Date()).getHours() >= 13) {
                                    item.bgColor = 'bg-red';
                                    item._index = 1;
                                }
                                else {
                                    item.bgColor = 'bg-pink';
                                    item._index = 2;
                                }
                            }
                            if (item.today_task.status == 2) {
                                item.bgColor = 'bg-yellow';
                                item._index = 3;
                            }
                            if (item.today_task.status == 3) {
                                item.bgColor = 'bg-green';
                                item._index = 4;
                            }
                        }

                        if (item.is_empty && !item.today_task) {
                            item.bgColor = 'bg-grey';
                            item._index = 110;
                        }

                        if (!item.next_order) {
                            item._index = 120;
                        }

                        item._index += item.check_status;

                    });

                    t.list.room = arr.sort((a, b) => a._index - b._index);
                    t.dict.room = listToDict(t.list.room);

                    axios.get('group').then(res => {
                        if (res.data.status == 1) {
                            let arr = res.data.options.items;
                            arr.forEach(group => {
                                group.rooms = [];
                                let roomIds = group.room_ids.split(',');
                                roomIds.forEach(roomId => {
                                    if (t.dict.room[roomId]) {
                                        t.dict.room[roomId].selected = true;
                                        group.rooms.push(t.dict.room[roomId]);
                                    }
                                });
                            });

                            t.list.group = arr;

                            t.list.group1.clear();
                            t.list.group2.clear();
                            t.list.group3.clear();

                            let idx = 1;
                            arr.forEach(item => {
                                t.list['group' + idx].push(item);
                                idx++;
                                if (idx > 3)
                                    idx = 1;
                            });
                        }
                    });

                    t.filterData();
                }
            });

        },

        filterData() {
            let t = this;

            t.list.item.clear();

            t.search.cleaner.clear();
            t.list.cleaner.forEach(item => {
                if (item.selected) {
                    t.search.cleaner.push(item);
                }
            });

            t.search.room.clear();
            t.list.room.forEach(item => {
                if (item.selected) {
                    t.search.room.push(item);
                }
            });

            let config = {
                bell_status: 'bell_status',
                clean_status: 'clean_status',
                check_status: 'check_status',
                source: 'source',
                cleaner: 'cleaner_id',
                room: 'id'
            };

            let values = {
                bell_status: [],
                clean_status: [],
                check_status: [],
                source: [],
                cleaner: [],
                room: []
            };

            for (const key in t.search) {
                if (key != 'people')
                    t.search[key].forEach(item => {
                        if (values[key] && values[key].push)
                            values[key].push(item.id);
                    });
            }

            t.list.room.forEach(item => {

                let pick = true;

                for (const key in values) {
                    let vs = values[key];
                    if (vs.length > 0) {
                        if (vs.indexOf(item[config[key]]) < 0) {
                            pick = false;
                        }
                    }
                }

                if (t.search.people && t.search.people != item.people)
                    pick = false;

                if (pick) {
                    item.delaySave = () => {

                        let t = this;

                        if (window.event.target) {
                            if (window.event.target.scrollHeight < 13)
                                window.event.target.style.height = '13px';
                            else
                                window.event.target.style.height = (window.event.target.scrollHeight) + 2 + 'px'; // 根据内容调整高度
                        }

                        if (item._timeoutID != null) {
                            window.clearTimeout(item._timeoutID);
                        }

                        let f = {
                            room_id: item.id,
                            date: t.todayStr,
                            inside_remark: item.inside_remark,
                            outside_remark: item.outside_remark
                        };

                        item._timeoutID = setTimeout(() => {
                            item._timeoutID = null;
                            axios.post('roomRemark/replace', f).then(res => {
                                if (res.data.status == 1) {

                                }
                            });
                        }, 1000);

                    }
                    if (item.remark) {
                        item.inside_remark = item.remark.inside_remark;
                        item.outside_remark = item.remark.outside_remark;
                    }
                    item.check_status_order = t.dict.check_status[item.check_status].order;
                    t.list.item.push(item);
                }
            });

            t.list.item = t.list.item.sort((a, b) => {
                return b.check_status_order - a.check_status_order;
            });

        },

        minusDate() {
            let t = this;

            if (t.today <= Date.today()) {
                A.err('現在および将来のデータへのアクセスのみ');
                return;
            }
            else {
                t.today.setDate(t.today.getDate() - 1);
                t.loadData();
                t.$forceUpdate();
            }
        },

        plusDate() {
            let t = this;
            t.today.setDate(t.today.getDate() + 1);
            t.loadData();
            t.$forceUpdate();
        },

        tapBell(item) {

            let t = this;

            if (item.checkInItem) {

                t.gridItem = item;
                t.showWindow = true;

                if (item.checkInItem.form_status == 1) {
                    t.boxName = 'unfill';
                }
                else if (item.checkInItem.form_status == 2) {
                    t.boxName = 'normal';
                }
            }

        },

        resolveUnfill() {
            let t = this;

            let width = 420;
            let height = 800;
            let leftPosition = (window.screen.width - width) / 2;
            let topPosition = (window.screen.height - height) / 2;
            let windowFeatures = 'width=' + width + ',height=' + height + ',left=' + leftPosition + ',top=' + topPosition + ',resizable=yes,scrollbars=yes';

            let popup = window.open(location.origin + '/#/form?rid=' + t.gridItem.checkInItem.room_id, '_blank', windowFeatures);

            function handleMsg(event) {
                if (event.source === popup && typeof event.data === 'string') {
                    window.removeEventListener('message', handleMsg);
                    t.gridItem.checkInItem.form_status = 2;
                    t.gridItem.bell_status = 2;
                    t.$forceUpdate();
                }
            }

            window.addEventListener('message', handleMsg);
        },

        goContact() {
            this.showWindow = false;
        },

        resetFilters() {
            let t = this;
            if (!t.filterName) {
                t.showFilter = false;
            }
            else {
                t.filterName = '';
            }
        },

        refreshTextboxs() {
            this.$nextTick(() => {
                let eles = document.querySelectorAll('.monitor-items textarea.input-box');

                eles.forEach(ele => {
                    if (ele.scrollHeight >= 13)
                        ele.style.height = (ele.scrollHeight) + 2 + 'px'; // 根据内容调整高度
                });
            });
        }

    },
    data() {
        return {
            showFilter: false,
            filterName: '',
            keywordSearch: {
                tag_name: '',
                cleaner_name: '',
                room_name: ''
            },
            showWindow: false,
            boxName: '',
            gridItem: null,
            today: Date.today(),
            todayStr: Date.today().format('yyyy-MM-dd'),
            search: {
                bell_status: [],
                clean_status: [],
                people: '',
                check_status: [],
                source: [],
                cleaner: [],
                room: []
            },
            list: {
                group: [],
                group1: [],
                group2: [],
                group3: [],
                tag: [
                    { id: 1, name: '京都', selected: false },
                    { id: 2, name: '大阪', selected: false },
                    { id: 3, name: '其他', selected: false },
                ],
                bell_status: [
                    { id: 1, text: 'Form 未提出', className: 'fill-red' },
                    { id: 2, text: 'Form 提出完了、異常なし', className: 'fill-white' },
                    { id: 3, text: '当日掃除があり、客なし', className: 'fill-black' },
                    { id: 4, text: '騒音大きい', className: 'fill-yellow' },
                    { id: 5, text: '注文あり', className: 'fill-purple' },
                ],
                clean_status: [
                    { id: 1, text: '清掃未開始' },
                    { id: 2, text: '清掃中' },
                    { id: 3, text: '清掃完了' },
                ],
                check_status: [
                    { id: 4, text: 'チェックイン可能', suffix: '<span style="color: #D992C5">可</span>', order: 5 },
                    { id: 1, text: 'チェックイン/アウト', suffix: '<span style="color: #4A9FBD">IN</span>', order: 4 },
                    { id: 2, text: 'チェックアウトだけ', suffix: '<span style="color: #E96365">OUT</span>', order: 3 },
                    { id: 3, text: '滞在中', suffix: '<span style="color: #9A9292">ST</span>', order: 2 },
                    { id: 0, text: '空室', suffix: '<span style="color: #341717">空</span>', order: 1 },
                ],
                source: [
                    { id: 'KL', text: 'KL：自社予約' },
                    { id: 'AG', text: 'AG：agoda' },
                    { id: 'AY', text: 'AY：Asiayo管理' },
                    { id: 'BB', text: 'BB：airbnb' },
                    { id: 'BK', text: 'BK：Booking' },
                    { id: 'VS', text: 'VS：Vacation STAY' },
                    { id: 'JR', text: 'JR：じやらん' },
                    { id: 'CT', text: 'CT：Trip(携程海外)' },
                    { id: 'RT', text: 'RT：Rakuten Travel' },
                    { id: 'XP', text: 'XP：Xpedia' },
                    { id: 'SF', text: 'SF：会社招待等' },
                ],
                room: [],
                cleaner: [],
                people: [],
                item: []
            },
            dict: {
                cleaner: {},
                room: {},
                clean_status: {},
                bell_status: {},
                people: {},
                source: {},
            },
            showFormPopover: false,
            showCleanStatusPopover: false,
            showPeoplePopover: false,
            showCheckStatusPopover: false,
            showSourcePopover: false,
            showRoomPopover: false,
            showCleanPopover: false,
            stats: {
                checkin: 0,
                checkout: 0,
                checkin_out: 0,
                continuous: 0,
                empty: 0,
            }
        };
    },
    computed: {
        filteredTags() {
            let t = this;

            let arr = [];

            t.list.tag.forEach(item => {
                if (t.keywordSearch.tag_name && (item.name.indexOf(t.keywordSearch.tag_name) > -1)) {
                    arr.push(item);
                }
            });

            return arr;
        },

        selectedTags() {
            let t = this;

            let arr = [];

            t.list.tag.forEach(item => {
                if (item.selected) {
                    arr.push(item);
                }
            });

            return arr;
        },

        filteredCleaners() {
            let t = this;

            let arr = [];

            t.list.cleaner.forEach(item => {
                if (t.keywordSearch.cleaner_name && (item.name.indexOf(t.keywordSearch.cleaner_name) > -1)) {
                    arr.push(item);
                }
            });

            return arr;
        },

        selectedCleaners() {
            let t = this;

            let arr = [];

            t.list.cleaner.forEach(item => {
                if (item.selected) {
                    arr.push(item);
                }
            });

            return arr;
        },

        filteredRooms() {
            let t = this;

            let arr = [];

            t.list.room.forEach(item => {
                if (t.keywordSearch.room_name && (item.name.indexOf(t.keywordSearch.room_name) > -1)) {
                    arr.push(item);
                }
            });

            return arr;
        },

        selectedRooms() {
            let t = this;

            let arr = [];

            t.list.room.forEach(item => {
                if (item.selected) {
                    arr.push(item);
                }
            });

            return arr;
        },


    }
};
